import React from "react"
import { ExtratoPagarmeFornecedorInicial } from "../models/extratoPagarmeFornecedorModel"
import type { ExtratoPagarmeFornecedorModel } from "../models/extratoPagarmeFornecedorModel"
import type { ExtratoPagarmeFornecedorActions } from "./extratoPagarmeFornecedorActions"

interface ExtratoPagarmeFornecedorContextValue {
    dados: ExtratoPagarmeFornecedorModel
    dispatch: React.Dispatch<ExtratoPagarmeFornecedorActions>
    erroCarregamento: string | null
    carregarExtrato: () => Promise<void>
}

export const ExtratoPagarmeFornecedorContext =
    React.createContext<ExtratoPagarmeFornecedorContextValue>({
        dados: ExtratoPagarmeFornecedorInicial,
        dispatch: () => undefined,
        erroCarregamento: null,
        carregarExtrato: async () => undefined,
    })
